import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Crown, BookOpen, BarChart2, Shield, LogIn, LogOut, User } from "lucide-react";

export default function Navbar() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const linkBase =
        "uppercase tracking-[0.22em] text-xs font-medium text-[#A1A1AA] hover:text-[#E6D59A] transition-colors";
    const active = "text-[#D4AF37]";

    return (
        <header
            data-testid="site-navbar"
            className="sticky top-0 z-50 backdrop-blur-xl bg-[#0a0a0a]/80 border-b"
            style={{ borderColor: "rgba(212,175,55,0.18)" }}
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
                <Link
                    to="/"
                    data-testid="brand-link"
                    className="flex items-center gap-3 group"
                >
                    <div className="relative w-9 h-9 flex items-center justify-center">
                        <div
                            className="absolute inset-0 rotate-45"
                            style={{
                                background:
                                    "linear-gradient(180deg,#e6d59a 0%, #d4af37 60%, #aa8529 100%)",
                            }}
                        />
                        <Crown className="relative w-4 h-4 text-[#0a0a0a]" strokeWidth={2.5} />
                    </div>
                    <div className="flex flex-col leading-none">
                        <span className="font-serif text-xl text-white tracking-tight">
                            EIGOO
                        </span>
                        <span className="eyebrow text-[10px] mt-0.5">Books · Hub</span>
                    </div>
                </Link>

                <nav className="hidden md:flex items-center gap-10">
                    <NavLink
                        to="/publish"
                        data-testid="nav-publish"
                        className={({ isActive }) => `${linkBase} ${isActive ? active : ""}`}
                    >
                        Publish
                    </NavLink>
                    <NavLink
                        to="/library"
                        data-testid="nav-library"
                        className={({ isActive }) => `${linkBase} ${isActive ? active : ""}`}
                    >
                        Library
                    </NavLink>
                    <NavLink
                        to="/comic/sovereign-commander"
                        data-testid="nav-sovereign"
                        className={({ isActive }) => `${linkBase} ${isActive ? active : ""}`}
                    >
                        Sovereign Commander
                    </NavLink>
                    {user && (
                        <NavLink
                            to="/stats"
                            data-testid="nav-stats"
                            className={({ isActive }) => `${linkBase} ${isActive ? active : ""}`}
                        >
                            My Reading
                        </NavLink>
                    )}
                    {(user?.role === "writer" || user?.role === "admin") && (
                        <NavLink
                            to="/writer"
                            data-testid="nav-writer"
                            className={({ isActive }) => `${linkBase} ${isActive ? active : ""}`}
                        >
                            Writer
                        </NavLink>
                    )}
                    {user?.role === "admin" && (
                        <NavLink
                            to="/admin"
                            data-testid="nav-admin"
                            className={({ isActive }) => `${linkBase} ${isActive ? active : ""}`}
                        >
                            Admin
                        </NavLink>
                    )}
                </nav>

                <div className="flex items-center gap-4">
                    {user ? (
                        <>
                            <span
                                data-testid="user-greeting"
                                className="hidden sm:flex items-center gap-2 text-xs text-[#A1A1AA] uppercase tracking-widest"
                            >
                                <User className="w-3.5 h-3.5 text-[#D4AF37]" />
                                {user.name}
                            </span>
                            <button
                                data-testid="logout-btn"
                                onClick={async () => {
                                    await logout();
                                    navigate("/");
                                }}
                                className="btn-ghost-gold !py-2 !px-4 text-[10px]"
                            >
                                <LogOut className="w-3.5 h-3.5" /> Sign out
                            </button>
                        </>
                    ) : (
                        <>
                            <Link
                                to="/login"
                                data-testid="nav-login"
                                className="btn-ghost-gold !py-2 !px-4 text-[10px]"
                            >
                                <LogIn className="w-3.5 h-3.5" /> Sign in
                            </Link>
                            <Link
                                to="/publish"
                                data-testid="nav-register"
                                className="btn-gold !py-2 !px-4 text-[10px] hidden sm:inline-flex"
                            >
                                Publish With Us
                            </Link>
                        </>
                    )}
                </div>
            </div>
            <div className="gold-rule" />
        </header>
    );
}
